export const relationshipTypes = [
  "Partner",
  "Child",
  "Sibling",
  "Volunteer",
  "Niece/Nephew",
  "Parent",
  "Friend",
  "Other"
];
